// removed by extract-text-webpack-plugin
module.exports = {"modal":"PackItem__modal___3u59W","overlay":"PackItem__overlay___fvSrY","inner":"PackItem__inner___2RJYy","title":"PackItem__title___3qAHV","description":"PackItem__description___3T4Kr","buttons":"PackItem__buttons___2Wcs8","fieldset":"PackItem__fieldset___QM_2j"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Modals/PackItem/PackItem.scss
// module id = 1271
// module chunks = 1